// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1o0BK","isCollapsed":"styles_isCollapsed__Hdi-l"};